import * as React from "react";
const SvgCallToAction = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v18h22V3zm-2 16H3v-3h18v3z",
  fill: "currentColor"
}));
export default SvgCallToAction;